"use client";

interface BlendedGradientProps {
    activeSection: 'flashcards' | 'mindmaps' | 'tests' | null;
    scrollProgress: number;
    className?: string;
    children?: React.ReactNode;
}

const sectionColors = {
    flashcards: '#E8B35B',
    mindmaps: '#004C87',
    tests: '#00857F'
};

export function BlendedGradient({ activeSection, scrollProgress, className = "", children }: BlendedGradientProps) {
    const lerpColor = (color1: string, color2: string, factor: number) => {
        const hex1 = color1.replace('#', '');
        const hex2 = color2.replace('#', '');
        const r1 = parseInt(hex1.substring(0, 2), 16);
        const g1 = parseInt(hex1.substring(2, 4), 16);
        const b1 = parseInt(hex1.substring(4, 6), 16);
        const r2 = parseInt(hex2.substring(0, 2), 16);
        const g2 = parseInt(hex2.substring(2, 4), 16);
        const b2 = parseInt(hex2.substring(4, 6), 16);

        const r = Math.round(r1 + (r2 - r1) * factor);
        const g = Math.round(g1 + (g2 - g1) * factor);
        const b = Math.round(b1 + (b2 - b1) * factor);

        return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    };

    const getCurrentColor = () => {
        if (activeSection) {
            return sectionColors[activeSection];
        }

        if (scrollProgress < 0.33) {
            const sectionProgress = scrollProgress / 0.33;
            return lerpColor(sectionColors.flashcards, sectionColors.mindmaps, sectionProgress);
        } else if (scrollProgress < 0.66) {
            const sectionProgress = (scrollProgress - 0.33) / 0.33;
            return lerpColor(sectionColors.mindmaps, sectionColors.tests, sectionProgress);
        } else {
            return sectionColors.tests;
        }
    };

    return (
        <div 
            className={`relative ${className}`}
            style={{
                backgroundColor: getCurrentColor(),
                transition: 'background-color 0.3s ease-out'
            }}
        >
            {children}
        </div>
    );
}
